import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getPasswordStrength } from './utils';

type PasswordStrengthProps = {
  password: string;
};

const SEGMENT_COLORS: Record<number, string> = {
  0: '#D9E2FF',
  1: '#D14343',
  2: '#E58C2A',
  3: '#2E5AE8',
  4: '#1F9D61',
};

const PasswordStrength = ({ password }: PasswordStrengthProps) => {
  const { t } = useTranslation();
  const { color, label, score } = getPasswordStrength({
    password,
    emptyLabel: t('register.passwordHint'),
    weakLabel: t('register.passwordStrength.weak'),
    mediumLabel: t('register.passwordStrength.medium'),
    strongLabel: t('register.passwordStrength.strong'),
    veryStrongLabel: t('register.passwordStrength.veryStrong'),
  });

  return (
    <Stack spacing={0.75}>
      <Stack direction='row' spacing={0.75}>
        {Array.from({ length: 4 }, (_, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              height: 4,
              borderRadius: 999,
              backgroundColor: index < score ? SEGMENT_COLORS[score] : SEGMENT_COLORS[0],
              transition: 'background-color 0.2s ease',
            }}
          />
        ))}
      </Stack>

      <Typography variant='body14rg' sx={{ color }}>
        {label}
      </Typography>
    </Stack>
  );
};

export default PasswordStrength;
